import './VerdictOverlay.css';

export default function VerdictOverlay({
  verdict,
  message,
  failures = [],
  previewUrl,
  spotCount = 0,
  onDismiss,
}) {
  if (!verdict) return null;

  const isNg = verdict === 'NG';
  const title = isNg ? 'ไม่ผ่าน' : 'ผ่าน';
  const reason =
    message ||
    (failures[0]?.message) ||
    (isNg ? 'ไม่ตรงตามเกณฑ์ Appearance' : 'ผ่านเกณฑ์ Appearance');

  return (
    <div className={`verdict-overlay ${isNg ? 'ng' : 'ok'}`}>
      <div className="verdict-card">
        <div className="verdict-title">{title}</div>
        <div className="verdict-count">พบ {spotCount} จุด</div>
        <div className="verdict-sub">{reason}</div>
        {isNg && failures?.length > 1 && (
          <ul className="verdict-fails">
            {failures.slice(0, 3).map((f) => (
              <li key={f.code}>{f.message}</li>
            ))}
          </ul>
        )}
        {previewUrl && (
          <img
            src={previewUrl}
            alt={`หลักฐานพบ ${spotCount} จุด`}
            className="verdict-photo"
          />
        )}
        {previewUrl && (
          <div className="verdict-note">
            บันทึกรูปพร้อมกรอบจุดแล้ว · พบ {spotCount} จุด
          </div>
        )}
        {onDismiss && (
          <button type="button" className="btn verdict-dismiss" onClick={onDismiss}>
            ปิด / ตรวจต่อ
          </button>
        )}
      </div>
    </div>
  );
}
